export const TenantSettingKeys = {
  CompanyName: 'UI-SERVERLESS.PUBLIC.NAME',
  OrderLinePrefix: 'UI-SERVERLESS.PUBLIC.ORDERLINEPREFIX',
  CurrencyCode: 'UI-SERVERLESS.PUBLIC.CURRENCY',
  BaseURL: 'UI-SERVERLESS.PUBLIC.BASEURL',
  Website: 'UI-SERVERLESS.PUBLIC.WEBSITE',
  InvoiceApi: 'UI-SERVERLESS.PUBLIC.USEINVOICEAPI',
  Links: {
    Tracking: 'UI-SERVERLESS.PUBLIC.LINKS.TRACKING'
  },
  // New (order-process) payments vs the legacy /order/payment page. `Enabled` covers every journey;
  // the per-journey keys let a single journey migrate ahead of the rest and act as ORs against it.
  // `SmartSendEnabled` is consumed by edge-smartsend-api, which builds the order payment link.
  Payments: {
    Enabled: 'UI-SERVERLESS.PUBLIC.ORDERPROCESS.PAYMENTSENABLED',
    PrePayEnabled: 'UI-SERVERLESS.PUBLIC.PREPAY.PAYMENTSENABLED',
    SmartSendEnabled: 'UI-SERVERLESS.PUBLIC.SMARTSEND.PAYMENTSENABLED'
  }
};
